import { render, staticRenderFns } from "./NewTemplate.vue?vue&type=template&id=995609ca&scoped=true"
import script from "./NewTemplate.vue?vue&type=script&lang=js"
export * from "./NewTemplate.vue?vue&type=script&lang=js"
import style0 from "./NewTemplate.vue?vue&type=style&index=0&id=995609ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "995609ca",
  null
  
)

export default component.exports